var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.structuredMessages, function (message_date, key) {
        return _c(
          "div",
          {
            key: message_date.sid,
            staticClass: "mb-4",
            attrs: { id: "messages_container" },
          },
          [
            _c("div", { staticStyle: { clear: "both" } }),
            _c(
              "v-container",
              { staticClass: "sticky my-4", staticStyle: { width: "100%" } },
              [
                _c(
                  "v-row",
                  { attrs: { align: "center" } },
                  [
                    _c("v-divider"),
                    _c("v-chip", { attrs: { small: "" } }, [
                      _vm._v(_vm._s(key || "New Messages")),
                    ]),
                    _c("v-divider"),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._l(message_date, function (message) {
              return _c(
                "div",
                { key: message.sid, attrs: { id: message.sid } },
                [
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "text-caption grey--text",
                        staticStyle: { clear: "both" },
                        style:
                          message.direction == "inbound"
                            ? "float:left;"
                            : "float:right;",
                      },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "span",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticStyle: {
                                                cursor: "pointer",
                                              },
                                            },
                                            "span",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            _vm._s(_vm.messageTime(message))
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              message.direction == "inbound"
                                ? _c(
                                    "span",
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.app.phoneNumberFormat(
                                            message.from
                                          )
                                        ) + " "
                                      ),
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("mdi-arrow-right"),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.app.phoneNumberFormat(
                                              message.to
                                            )
                                          )
                                      ),
                                    ],
                                    1
                                  )
                                : _c(
                                    "span",
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.app.phoneNumberFormat(message.to)
                                        ) + " "
                                      ),
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("mdi-arrow-left"),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.app.phoneNumberFormat(
                                              message.from
                                            )
                                          )
                                      ),
                                    ],
                                    1
                                  ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  message.type == "sms" &&
                  message.body.length > 0 &&
                  message.status != "queued"
                    ? _c("div", {
                        staticClass: "px-4 py-2 mb-4 white--text text-left",
                        class:
                          message.direction == "inbound"
                            ? "secondary"
                            : "primary",
                        staticStyle: {
                          display: "inline-block",
                          clear: "both",
                          "border-radius": "15px",
                          "max-width": "80%",
                        },
                        style:
                          message.direction == "inbound"
                            ? "float:left;"
                            : "float:right;",
                        domProps: {
                          innerHTML: _vm._s(_vm.formatBody(message.body)),
                        },
                      })
                    : _vm._e(),
                  message.status == "queued"
                    ? _c(
                        "div",
                        { staticClass: "my-4", staticStyle: { clear: "both" } },
                        [
                          _c("v-progress-circular", {
                            staticClass: "float-right",
                            attrs: { "x-small": "", indeterminate: "" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticStyle: { clear: "both" } },
                    _vm._l([0, 1, 2, 3, 4, 5, 6, 7, 8, 9], function (x) {
                      return _c("span", { key: `image-${message.sid}-${x}` }, [
                        message.type == "sms" && message[`mediaurl${x}`]
                          ? _c(
                              "span",
                              [
                                message[`mediaurl${x}`].indexOf("image/") > 0 ||
                                message[`mediaurl${x}`].indexOf(
                                  "contentType"
                                ) == -1
                                  ? _c(
                                      "v-img",
                                      {
                                        staticClass:
                                          "rounded-lg mb-2 show-image white",
                                        style:
                                          message.direction == "inbound"
                                            ? "float:left;"
                                            : "float:right;",
                                        attrs: {
                                          "lazy-src": _vm.app.placeholder_img,
                                          src: message[`mediaurl${x}`],
                                          "max-width": "70%",
                                        },
                                        on: {
                                          load: function ($event) {
                                            return _vm.scrollToBottom()
                                          },
                                          click: function ($event) {
                                            return _vm.showImage(
                                              message[`mediaurl${x}`]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-overlay",
                                          {
                                            staticClass: "text-center",
                                            attrs: {
                                              opacity: 0.8,
                                              absolute: true,
                                              value:
                                                message.status == "sent" ||
                                                message.SmsStatus == "sent",
                                            },
                                          },
                                          [
                                            _vm._v(" Sending image... "),
                                            _c("v-progress-linear", {
                                              attrs: {
                                                indeterminate: "",
                                                color: "success",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-overlay",
                                          {
                                            staticClass:
                                              "text-center error--text",
                                            attrs: {
                                              absolute: true,
                                              value:
                                                message.status == "failed" ||
                                                message.SmsStatus == "failed",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-chip",
                                              {
                                                staticClass: "px-4",
                                                attrs: { color: "error" },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { left: "" } },
                                                  [
                                                    _vm._v(
                                                      "mdi-alert-circle-outline"
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" Failed to send "),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                message[`mediaurl${x}`].indexOf("audio/") > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "px-4 py-2 mb-4 white--text text-right",
                                        class:
                                          message.direction == "inbound"
                                            ? "secondary float-left"
                                            : "primary float-right",
                                        staticStyle: {
                                          display: "inline-block",
                                          clear: "both",
                                          "border-radius": "15px",
                                          "max-width": "80%",
                                        },
                                      },
                                      [
                                        _c("audio-player", {
                                          attrs: {
                                            label: "Audio",
                                            url: message[`mediaurl${x}`],
                                            playerid: "audio-player",
                                            expanded: true,
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                message[`mediaurl${x}`].indexOf(
                                  "application/"
                                ) > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "px-4 py-2 mb-4 white--text text-right",
                                        class:
                                          message.direction == "inbound"
                                            ? "secondary float-left"
                                            : "primary float-right",
                                        staticStyle: {
                                          display: "inline-block",
                                          clear: "both",
                                          "border-radius": "15px",
                                          "max-width": "80%",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              href: message[`mediaurl${x}`],
                                              text: "",
                                              "x-small": "",
                                              target: "_blank",
                                            },
                                          },
                                          [
                                            _c("v-icon", [_vm._v("mdi-file")]),
                                            _vm._v(" File "),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ])
                    }),
                    0
                  ),
                  message.type == "voice"
                    ? _c(
                        "div",
                        {
                          staticClass: "px-4 py-2 mb-4 white--text",
                          class:
                            message.direction == "inbound"
                              ? "text-right secondary"
                              : "text-left primary",
                          staticStyle: {
                            display: "inline-block",
                            clear: "both",
                            "border-radius": "15px",
                            "max-width": "80%",
                          },
                          style:
                            message.direction == "inbound"
                              ? "float:left;"
                              : "float:right;",
                        },
                        [
                          message.recording && message.recording.length > 0
                            ? _c("audio-player", {
                                attrs: {
                                  label:
                                    message.direction == "inbound"
                                      ? "Incoming Call"
                                      : "Outgoing Call",
                                  url: message.recording,
                                  playerid: "audio-player",
                                  expanded: true,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              )
            }),
          ],
          2
        )
      }),
      _c(
        "v-dialog",
        {
          attrs: { "overlay-opacity": "1", align: "center", justify: "center" },
          model: {
            value: _vm.show_image_dialog,
            callback: function ($$v) {
              _vm.show_image_dialog = $$v
            },
            expression: "show_image_dialog",
          },
        },
        [
          _c(
            "v-layout",
            { staticStyle: { height: "100%" } },
            [
              _vm.show_image_url
                ? _c("v-img", {
                    staticClass: "show-image white",
                    attrs: { src: _vm.show_image_url, contain: "" },
                    on: {
                      click: function ($event) {
                        _vm.show_image_dialog = false
                        _vm.show_image_url = null
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }